export const parseDate = (dateStr: any) => {
  if (!dateStr) return new Date(0);

  const parts = dateStr.split("-");

  // if first part is 4 digits => YYYY-MM-DD
  if (parts[0].length === 4) {
    return new Date(dateStr);
  }

  // otherwise DD-MM-YYYY
  return new Date(parts.reverse().join("-"));
};

// handles both:
// "2025-05-13"
// "13-05-2025"
